module.exports = __webpack_public_path__ + "img/img_baozheng.724b27bc.png";